const events = {
  TOGGLE_COLLAPSE: 'TOGGLE_COLLAPSE',
}

export default events
